import MainLayout from '@/components/layout/applicant/MainLayout.vue';
import RegionJson from "@/assets/json/region.json";
// import Pagination from "laravel-vue-pagination";
import axios from "axios";
import { ConvertNumService } from "@/assets/js/convertNumberService.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
const convertNumberService = new ConvertNumService();

export default {
    name: "JobListingCompanyDetail",
    components: {
        MainLayout,
        // Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            company: {
                company_logo: "",
                company_name: "",
                email: "",
                phone_number: "",
                address: "",
                town: "",
                region: "",
                company_detail: ""
            },
            keyword: "",
            jobList: {},
            jobType: [{
                    value: "1",
                    name: "Full-time"
                },
                {
                    value: "2",
                    name: "Part-time"
                },
                {
                    value: "3",
                    name: "Internship"
                },
                {
                    value: "4",
                    name: "Freelance"
                },
                {
                    value: "5",
                    name: "Remote Job"
                }
            ],
            regionArr: RegionJson,
            job_count: ""
        };
    },

    watch: {
        '$route.params.id'(newId) {
            if (newId) {
                this.getCompanyDetail();
                this.getJobDetail();
                window.scrollTo(0, 0);
            }
        }
    },

    methods: {
        getCompanyDetail() {
            axios.get("/company/dashboard/" + this.$route.params.id)
                .then(response => {
                    if (!response.data || !response.data.id) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.company = response.data;
                })
                .catch(error => {
                    console.log("Company Dashboard API Error", error);
                    this.$router.push({ name: "notFound" });
                });
        },

        getJobDetail(page = 1) {
            axios.get("/job_listing/detail/" + this.$route.params.id +"?page=" +page)
                .then(response => {
                    this.jobList = response.data;
                    this.job_count = convertNumberService.convertEng2Mm(this.jobList.total.toString());

                    let robotsMeta = document.querySelector('meta[name="robots"]');
                    if (this.jobList.total === 0) {
                        if (!robotsMeta) {
                            robotsMeta = document.createElement('meta');
                            robotsMeta.name = 'robots';
                            document.head.appendChild(robotsMeta);
                        }
                        robotsMeta.content = 'noindex, follow';
                    } else {
                        if (robotsMeta) {
                            robotsMeta.remove();
                        }
                    }
                })
                .catch(error => {
                    console.log("Job Detail API Error", error);
                });
        },
        getJobType(job_type) {
            if (job_type == '1') {
              this.job_type = 'Full-time';
            } else if (job_type == '2') {
              this.job_type = 'Part-time';
            } else if (job_type == '3') {
              this.job_type = 'Internship';
            } else if (job_type == '4') {
              this.job_type = 'Freelance';
            } else if (job_type == '5') {
              this.job_type = 'Remote Job';
            } else {
              this.job_type = 'သတ်မှတ်ထားခြင်းမရှိပါ';
            }
            return this.job_type;
          },

        timeAgo(dateString) {
            if (!dateString) return '';
            const parsedDate = new Date(dateString.replace(/-/g, '/'));
            const seconds = Math.floor((new Date() - parsedDate) / 1000);

            let interval = Math.floor(seconds / 31536000);
            if (interval >= 1) return interval + (interval === 1 ? " year ago" : " years ago");

            interval = Math.floor(seconds / 2592000);
            if (interval >= 1) return interval + (interval === 1 ? " month ago" : " months ago");

            interval = Math.floor(seconds / 86400);
            if (interval >= 1) return interval + (interval === 1 ? " day ago" : " days ago");

            interval = Math.floor(seconds / 3600);
            if (interval >= 1) return interval + (interval === 1 ? " hour ago" : " hours ago");

            interval = Math.floor(seconds / 60);
            if (interval >= 1) return interval + (interval === 1 ? " minute ago" : " minutes ago");

            return "just now";
        },

        formatNumber(value) {
            if (value === undefined || value === null) return '';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    },

    mounted() {
        this.getCompanyDetail();
        this.getJobDetail();
    },

    destroyed() {
        const robotsMeta = document.querySelector('meta[name="robots"]');
        if (robotsMeta) {
            robotsMeta.remove();
        }
    }
};
